import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import {
  RepairTrackingCounters,
  RepairTrackingSearchItem,
} from '../../interfaces/repair-tracking.interface';
import { LmrServices } from '../../services/lmr.service';

@Component({
  selector: 'app-repair-tracking',
  templateUrl: './repair-tracking.component.html',
  styleUrls: ['./repair-tracking.component.sass'],
})
export class RepairTrackingComponent implements OnInit {
  counters: RepairTrackingCounters = {
    awaitingRepair: 0,
    completedWithoutRepair: 0,
    completedWithRepair: 0,
  };
  term = '';
  searchedTerm = '';
  items: RepairTrackingSearchItem[] = [];
  searched = false;
  searching = false;

  constructor(
    private lmrService: LmrServices,
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService
  ) {}

  ngOnInit(): void {
    this.loadCounters();
    const term = this.route.snapshot.queryParamMap.get('term');
    if (term) {
      this.term = term.slice(0, 60);
      this.search();
    }
  }

  loadCounters(): void {
    this.lmrService.getRepairTrackingCounters().subscribe({
      next: counters => (this.counters = counters),
      error: () => this.toastr.error('Não foi possível carregar os contadores de reparo.'),
    });
  }

  search(): void {
    const term = this.term.trim();
    if (!term) {
      this.toastr.warning('Informe o Trade, a nota fiscal ou o IMEI.');
      return;
    }

    this.term = term.slice(0, 60);
    this.searchedTerm = this.term;
    this.searching = true;
    this.lmrService.searchRepairTracking(this.term).subscribe({
      next: response => {
        this.items = response?.items ?? [];
        this.searched = true;
        this.searching = false;
      },
      error: () => {
        this.items = [];
        this.searched = true;
        this.searching = false;
        this.toastr.error('Não foi possível pesquisar os trades. Verifique o termo informado.');
      },
    });
  }

  openDetails(item: RepairTrackingSearchItem): void {
    this.router.navigate(['../acompanhamento-reparo', item.tradeId], { relativeTo: this.route });
  }
}
